import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';
import useDocsCarrierProfile from 'hooks/useDocsCarrierProfile/useDocsCarrierProfile';
import qs from 'query-string';
import Spinner from 'components/Spinner';
import { DOC_STEPS } from 'utils/constants/routes';
import { useAuth } from 'hooks/useAuth/useAuth';

const Documents = ({ className }) => {
  const { t } = useTranslation('Documents');
  const {
    loadingProfile,
    carrierProfile,
    error: profileError,
    carrierUuid,
  } = useDocsCarrierProfile();
  const location = useLocation();
  const parsedURL = qs.parse(location.search);
  const isStaff = parsedURL?.staff;
  const history = useHistory();
  const { profile } = useAuth();

  useEffect(() => {
    if (
      carrierProfile &&
      carrierProfile.step !== undefined &&
      !loadingProfile &&
      !profileError
    ) {
      history.push(
        `${DOC_STEPS[carrierProfile.step](carrierUuid)}${location.search}`
      );
    }
  }, [
    carrierProfile,
    loadingProfile,
    profileError,
    isStaff,
    history,
    carrierUuid,
    location.search,
  ]);

  if (profileError) {
    return (
      <div className={className} data-testid="documents">
        <div className="documents">
          <div className="documents__error" data-testid="documents__error">
            {t('errorGettingDocuments')}
          </div>
        </div>
      </div>
    );
  }

  if (loadingProfile || !profile) {
    return (
      <div className={className} data-testid="documents">
        <div className="documents2">
          <div className="documents__loading" data-testid="documents__loading">
            <Spinner />
          </div>
        </div>
      </div>
    );
  }

  return null;
};
Documents.propTypes = {
  className: PropTypes.string,
};
export default Documents;
